import Radioaizer from 'Global/Components/CommonComponents/Radioaizer/Radioaizer';
import { fethAppointmentTimes } from 'Routes/Public/GetNewTurn/adapaters/fethAppointmentTimes';
import { selectedDayAtom } from 'Routes/Public/GetNewTurn/shared/selected.day';
import { useAtom } from 'jotai';
import React, { useEffect, useMemo, useState } from 'react';
import TimeButton from './TimeButton';
import { selectedTimeAtom } from 'Routes/Public/GetNewTurn/shared/selected.time';
import i18next from 'i18next';
import { GetNobatPrefrences } from 'utils/GetNobatPrefrences';
import { Alert } from '@mui/material';
import FindLangKey from 'Global/Functions/FindLangKey/FindLangKey';

const Times = () => {
  const prefrences = GetNobatPrefrences();

  const showTimeNobat = prefrences
    ? prefrences?.filter(
        (prefrence) =>
          prefrence.Key === 'webAppshowTimeNobat'
      )[0]?.Value === 'True'
    : null;

  const [selectedDay] = useAtom(selectedDayAtom);

  const [selectedTime, setSelectedTime] = useAtom(
    selectedTimeAtom
  );

  const [timeList, setTimeList] = useState(null);

  const full_label = FindLangKey(
    'get-new-turn-turn-label-full-queue'
  );

  const flexDirection = useMemo(()=>  i18next.language === 'fa' ||
  i18next.language === 'ar'
    ? 'row-reverse'
    : 'row',[selectedDay]);

   const timeRowStyle = useMemo(()=>({ display: 'flex',
    flexDirection: 'row',
    overflowX: 'auto',
    maxWidth: '92vw',
    flexDirection:flexDirection}),[selectedDay])


    console.log('flexDirection-->',flexDirection)

  useEffect(() => {
    if (selectedDay) {
      setTimeList();
      setSelectedTime();
      fethAppointmentTimes(selectedDay?.Id, setTimeList);
    }
  }, [selectedDay]);

  useEffect(() => {
    if (timeList) {
      setSelectedTime(timeList[0]);
    }
    return () => {
      setSelectedTime(null);
    };
  }, [JSON.stringify(timeList)]);

  return (
    <React.Fragment>
      <div
        style={{
          display: !showTimeNobat ? 'none' : 'flex',
          flexDirection: 'row',
          overflow: 'auto',
          maxWidth: '92vw',
          flexDirection:
            i18next.language === 'fa' ||
            i18next.language === 'ar'
              ? 'row-reverse'
              : 'row',
        }}
      >
        {timeList?.length === 0 ? (
          <Alert
            severity="error"
            sx={{
              textAlign: 'center',
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {full_label}
          </Alert>
        ) : (
          <Radioaizer
            direction={flexDirection}
            elements={timeList?.map((time) => (
              <TimeButton
                time={time}
                selectedTime={selectedTime}
              />
            ))}
            onSelectFunction={(index) => {
              setSelectedTime();
              setSelectedTime(timeList[index]);
            }}
            justPassSelect={true}
            justifyContent="unset"
          />
        )}
      </div>
    </React.Fragment>
  );
};

export default Times;
